import script from "./mySelf.vue?vue&type=script&setup=true&lang=js"
export * from "./mySelf.vue?vue&type=script&setup=true&lang=js"

import "./mySelf.vue?vue&type=style&index=0&id=17476907&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17476907"]])

export default __exports__